import { useLocation, Navigate } from "react-router-dom";
import React from "react";
import ResumenValidado from "../components/ResumenValidado";

const ResumenValidadoPage = () => {
    let validation;
    try {
        const location = useLocation();
        validation = location.state;
    } catch {
        
    }

    return (
        <>
            {validation !== undefined ? 
                <ResumenValidado validation={validation} /> 
                : 
                <Navigate to="/" replace={true} />
            }
        </>
    );
}

export default ResumenValidadoPage;
